<template>
  <FKBreadCrumb :page="$t('page.create')" :title="$t('page.create_edit_zone')">
    <FKBreadCrumbItem :page="$t('page.zones')" to="/zones" />
  </FKBreadCrumb>
  <ZoneForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import ZoneForm from "@/components/FK/Zones/ZoneForm.vue";

export default defineComponent({
  name: "CreateZonePage",
  components: {
    FKBreadCrumb,
    FKBreadCrumbItem,
    ZoneForm,
  },
});
</script>